export { default } from './CourseApply';
export type { Props, Props as CourseApplyProps } from './CourseApply';
